export enum OptimizelyEvents {
    UC_BALANCE_UPDATE = 'uc_balance_update',
    UC_BOTTOM_NAVIGATION_BAR = 'uc_bottom_navigation_bar',
}
